















































































































































interface Form {
  title: string | undefined;
  banner: string | undefined;
  type: string | undefined;
  appid: string | undefined;
  app_path: string | undefined;
}
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const uuidv4 = require('uuid/v4');
const { VUE_APP_API } = process.env;
const API = {
  add: `${VUE_APP_API}/qy/weixin/mina/banner/create`,
  update: `${VUE_APP_API}/qy/weixin/mina/banner/update`,
};
const UPLOAD_DIR = {
  banner: 'banner',
};

@Component({
  components: {
    SingleImageUpload,
  },
})
export default class CarouselDetail extends Vue {
  isLoading: boolean = false;
  formItemLayout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  UPLOAD_DIR: any = UPLOAD_DIR;
  form: Form = {
    title: '',
    banner: '',
    type: '1',
    appid: '',
    app_path: '',
  };
  validate: any = {
    title: {},
    banner: {},
    appid: {},
  };
  previewVisible: boolean = false;
  previewImage: string = '';
  is_appid_modal: boolean = false;
  modal_title: any = '';
  modal_content: any = '';
  default_status: any = ''; // 编辑时默认的状态值
  banner_item: any = {};
  package_type: number = 1;
  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  @Watch('form.banner')
  onScheduleChange(val: string) {
    this.checkChange('banner');
  }

  beforeLogoUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  handlePreview(imageUrl: string) {
    this.previewImage = imageUrl;
    this.previewVisible = true;
  }

  handlePreviewCancel() {
    this.previewVisible = false;
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'title') {
      if (!this.form.title) {
        this.validate.title.status = 'error';
        this.validate.title.error = '请输入轮播图名称';
        error = '1';
      } else {
        this.validate.title.status = '';
        this.validate.title.error = '';
      }
      return error;
    } else if (field === 'banner') {
      if (!this.form.banner) {
        this.validate.banner.status = 'error';
        this.validate.banner.error = '请上传banner图片';
        error = '1';
      } else {
        this.validate.banner.status = '';
        this.validate.banner.error = '';
      }
      return error;
    } else if (field === 'appid') {
      if (this.form.type === '1' && !this.form.appid) {
        this.validate.appid.status = 'error';
        this.validate.appid.error = '请输入想要跳转的小程序appid';
        error = '1';
      } else {
        this.validate.appid.status = '';
        this.validate.appid.error = '';
      }
      return error;
    }
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.validate) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  confirm() {
    this.is_appid_modal = false;
    const form = this.form;
    const send_data: any = {
      title: form.title,
      banner: form.banner,
      type: form.type,
    };
    if (form.type === '1') {
      send_data.jump_appid = form.appid;
      send_data.jump_path = encodeURIComponent(form.app_path as any);
    }
    if (!this.isNew) {
      send_data.id = this.id;
    }
    const post_url = this.isNew ? API.add : API.update;
    this.$axios.post(post_url, send_data).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        console.debug(remote.message);
        return;
      }

      this.$message.success('保存成功');
      this.$router.push('/operation/carousel-list');
    });
  }

  submit() {
    if (this.validator()) {
      this.confirm();
    }
  }

  created() {
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
    if (!this.isNew) {
      const item = storage.getItem('banner:item');
      this.banner_item = item;
      this.form = {
        title: this.banner_item.title,
        banner: this.banner_item.banner,
        type: String(this.banner_item.type),
        appid: this.banner_item.jump_appid,
        app_path: decodeURIComponent(this.banner_item.jump_path),
      };
    }
  }
}
